<template>
	<div class="vehicle-map">
		<div class="left">
			<divBox title="综合态势（近7日）">
				<div v-if="zongheSevenDaysData && zongheSevenDaysData.length" class="flex zonghe">
					<div
						v-for="(item, i) in zongheSevenDaysData"
						:key="'zongheSevenDaysData' + i"
						:style="{width: '33%'}">
						<div class="label">{{ item.label }}</div>
						<div class="value" :style="{color: item.color}">{{ item.value }}<span v-show="item.label === '运营里程(km)'" class="unit">万</span></div>
					</div>
				</div>
			</divBox>
			<divBox title="综合态势（累计）">
				<div v-if="zongheAllData && zongheAllData.length" class="flex zonghe">
					<div 
						v-for="(item, i) in zongheAllData"
						:key="'zongheAllData' + i"
						:style="{width: '50%'}">
						<div class="label">{{ item.label }}</div>
						<div class="value" :style="{color: item.color}">{{ item.value }}</div>
					</div>
				</div>
			</divBox>
			<divBox title="车辆类型占比">
				<myEchart
					v-if="vehicleProportionShow"
					:id="'VehicleProportion'"
					:options="vehicleProportionOptions" />
			</divBox>
			<divBox title="乘用车&商用车换电对比">
				<myEchart
					v-if="cheliangComparisonShow"
					:id="'CheliangComparison'"
					:options="cheliangComparisonOptions" />
			</divBox>
		</div>
		<div v-if="!showVehicleControl" class="center" style="position: relative;">
			<Map2D v-if="!changeMapBtn" />
			<Map3D v-show="changeMapBtn" />
			<div v-if="showBack" class="goback" @click="goback">
				<img class="location" src="@/assets/images/site/arrow_small.png" alt="">
				返回
			</div>
			<!-- 2d/3d 切换 -->
			<div :class="changeMapBtn ? 'show2dBtn show3dBtn' : 'show2dBtn'" @click="clickMapBtn"></div>
		</div>
		<div v-else class="center" style="position: relative;">
			<carsmap ref="carsmap"></carsmap>
			<div v-if="showBack" class="goback" @click="goback">
				<img class="location" src="@/assets/images/site/arrow_small.png" alt="">
				返回
			</div>
		</div>
		<div class="right">
			<divBox title="车辆分布地" style="flex: 3;">
				<div style="height: 100%;">
					<myEchart
						:style="{height: `${echartHeight}%`}"
						v-if="vehicleDistributionShow"
						:id="'VehicleDistribution'"
						:options="vehicleDistributionOptions" />
				</div>
			</divBox>
			<divBox title="24h充换电次数分布">
				<myEchart
					v-if="powerChangeTimeShow"
					:id="'PowerChangeTime'"
					:options="powerChangeTimeOptions" />
			</divBox>
		</div>
	</div>
</template>

<script>
import Map2D from "../map/2dMap"
import Map3D from '../map/3dMap'
import divBox from '../divBox'
import myEchart from './../charts/echarts'
import carsmap from '@/views/components/carsmap'
import { dataInterface } from '@/api/dataInterfaceApi'
import * as echarts from 'echarts5'
export default {
	components: {
		Map2D,
		Map3D,
		divBox,
		myEchart,
		carsmap,
	},
	data() {
		return {
			showBack: false,
			showVehicleControl: false, // 显示多车监控
			showMapBtn: false,
			changeMapBtn: false,

			zongheSevenDaysData: [], // 综合7天数据
			zongheAllData: [], // 综合累计
			// 车辆占比
			vehicleProportionOptions: {}, 
			vehicleProportionShow: false,
			// 乘用车&商用车换电对比
			cheliangComparisonOptions: {},
			cheliangComparisonShow: false,
			// 车辆分布地
			vehicleDistributionOptions: {},
			vehicleDistributionShow: false,
			echartHeight: 100,
			// 换电次数时间分布
			powerChangeTimeOptions: {},
			powerChangeTimeShow: false,
		};
	},
	props: {
		type: {
			type: String,
			default: () => ("")
		}
	},
	watch: {
		type: {
			handler(newData, oldData) {
				console.log('newDatanewDatanewData', newData)
				if (newData && newData == 'nationwideSite') {
					this.showMapBtn = true;
				}
			},
			immediate: true,
			deep: true
		},
	},
	mounted() {
		console.log('showMapBtn', this.showMapBtn)
		this.changeMapBtn = localStorage.getItem('changeMapBtn') == 'true' ? true : false
		this.showVehicleControl = this.$route.name == 'vehicleControl' || this.$route.name == 'vehicleControlYM'
		// 返回
		this.showBack = this.$route.name !== 'vehicleMap'
		if(this.showVehicleControl) {
			this.$nextTick( () => {
				this.$refs.carsmap.init(this.$route.query.cityName, '', this.$route.query.value)
			})
		}
	},
	methods: {
		getData(data) {
			console.log('adfadfadsf', data)
			// 综合态势7天
			this.zongheSevenDays(data)
			// 综合态势累计
			this.zongheAll(data)
			// 车辆类型占比
			this.cheliangProportion(data)
			// 乘用车&商用车换电对比
			this.cheliangComparison(data)
			// 车辆分布地
			this.vehicleDistribution(data)
			// 换电次数时间分布
			this.powerChangeTime(data)
		},
		// 综合态势7天
		zongheSevenDays(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-综合态势7',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000',
				'@OPER_TYPE':'充换电'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
				this.zongheSevenDaysData.push({
					value: data.vehicle_avtive_num,
					label: '活跃车辆数',
					color: '#36FBFB'
				})
				this.zongheSevenDaysData.push({
					value: data.new_acc_vehilce_num,
					label: '新增入网车辆',
					color: '#43FFB9'
				})
				this.zongheSevenDaysData.push({
					value: data.vehicle_active_rate,
					label: '车辆活跃度',
					color: '#FFFFFF'
				})
				this.zongheSevenDaysData.push({
					value: (parseFloat(data.exchange_mileage || 0) / 10000).toFixed(2) ,
					label: '运营里程(km)',
					color: '#179DFF'
				})
				this.zongheSevenDaysData.push({
					value: data.power_exchange_num,
					label: '充换电次数',
					color: '#36FBFB'
				})
			})
			.catch((err) => {
				console.log(err);
			});
		},
		// 综合态势累计
		zongheAll(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-综合态势lj',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res && res[0] || {}
				this.zongheAllData.push({
					value: data.acc_exchange_vehicle_num,
					label: '累计充换电车辆',
					color: '#36FBFB'
				})
				this.zongheAllData.push({
					value: (parseFloat(data.acc_exchange_elect || 0) / 10000).toFixed(2) + '万',
					label: '累计充换电电量(kwh)',
					color: '#43FFB9'
				})
				this.zongheAllData.push({
					value: (parseFloat(data.acc_exchange_mileage || 0) / 10000).toFixed(2) + '万',
					label: '累计运营里程(km)',
					color: '#FFFFFF'
				})
				this.zongheAllData.push({
					value: data.acc_power_exchange_num,
					label: '累计充换电次数',
					color: '#179DFF'
				})
			})
			.catch((err) => {
				console.log(err);
			});
		},

		// 车辆类型占比
		cheliangProportion(data = {}) {
			let params = {}
			// let query = this.$route.query
			params = {
				'enCode': 'quanguo-车辆类型占比',
				// '@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res || []
				let data1 = (parseFloat(data[0] && data[0].value || 0) * 100).toFixed(2)
				let data2 = (parseFloat(data[1] && data[1].value || 0) * 100).toFixed(2)
				this.vehicleProportionOptions = {
					color: ['#1083F9', '#77E8A9'],
					tooltip: {
						trigger: 'item'
					},
					legend: {
						top: '40%',
						left: 'left',
						orient: 'vertical',
						// icon: 'circle',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
					},
					series: [{
						name: '',
						type: 'pie',
						left: '20%',
						radius: ['30%', '70%'],
						avoidLabelOverlap: false,
						emphasis: {
							label: {
								show: true,
								fontSize: 40,
								fontWeight: 'bold'
							}
						},
						data: [
							{ value: data1, name: `乘用车: ${data1}%` },
							{ value: data2, name: `商用车: ${data2}%` },
						]
					}]
				}
				this.vehicleProportionShow = true
				// // 乘用车占比（需要乘以100得到占比）
				// this.VehicleProportion.passenger_rate = data.passenger_rate
				// // 商用车占比（需要乘以100得到占比）
				// this.VehicleProportion.commercial_rate = data.commercial_rate
			})
		},

		// 乘用车&商用车换电对比
		cheliangComparison(data = {}) {
			let params = {}
			// let query = this.$route.query
			params = {
				'enCode': 'quanguo-乘用车商用车换电对比',
				// '@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res) return
				let data = res || []
				let typeL = ['vehicle_power_exchange_up_num', 'consumption_elect', 'exchange_mileage']
				let unit = ['辆', 'w度', 'w公里']
				let typeL1 = ['vehicle_power_exchange_up_num_rate', 'consumption_elect_rate', 'exchange_mileage_rate']
				this.cheliangComparisonOptions = {
					tooltip: {
						trigger: 'axis',
						formatter: function (params) {
							return (
								params[0].name + '<br>' +
								(data[0].vehicle_type == 'passenger_vehicle' ? '乘用车：' : '商用车：') +
								params[0].value + '%&nbsp;&nbsp;&nbsp;&nbsp;' +
								(params[0].dataIndex > 0 ? (data[0][typeL[params[0].dataIndex]] / 10000).toFixed(2) : data[0][typeL[params[0].dataIndex]]) + `${unit[params[0].dataIndex]}<br>` +
								(data[1].vehicle_type == 'passenger_vehicle' ? '乘用车：' : '商用车：') +
								params[1].value + '%&nbsp;&nbsp;&nbsp;&nbsp;' +
								(params[0].dataIndex > 0 ? (data[1][typeL[params[0].dataIndex]] / 10000).toFixed(2) : data[1][typeL[params[0].dataIndex]]) + `${unit[params[0].dataIndex]}`
							)
						},
					},
					legend: {
						right: 'left',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
					},
					xAxis: [{
						type: 'category',
						data: ['活跃车辆数', '消费电量', '行驶里程'],
						splitLine: {
							show: false,
						},
						axisLabel: {
							color: '#fff'
						}
					}],
					yAxis: [{
						type: 'value'
					}],
					series: data.map((item, i) => {
						return {
							name: `${item.vehicle_type == 'passenger_vehicle' ? '乘用车' : '商用车'}`,
							type: 'bar',
							barWidth: 20,
							stack: 'cheliangComparison',
							emphasis: {
								focus: 'series'
							},
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: i == 0 ? '#36A1FF' : '#00FFD6' },
									{ offset: 1, color: i == 0 ? '#1968FF' :'#3DCAFF' }
								])
							},
							data: typeL1.map(type => {
								return (parseFloat(item[type] || 0) * 100).toFixed(2)
							})
						}
					})
				}
				this.cheliangComparisonShow = true
				// // 乘用车占比（需要乘以100得到占比）
				// this.VehicleProportion.passenger_rate = data.passenger_rate
				// // 商用车占比（需要乘以100得到占比）
				// this.VehicleProportion.commercial_rate = data.commercial_rate
			})
		},

		// 车辆分布地
		vehicleDistribution(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-车辆分布地',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				let data = res.sort(function(a, b) { return (parseFloat(a.vehicle_num) - parseFloat(b.vehicle_num))})
				let xAxis = []
				let yAxis = []
				this.echartHeight = data.length < 10 ? data.length * 10 : 100
				data.map(item => {
					xAxis.push(item.address || '')
					yAxis.push({
						value: item.vehicle_num || '',
						itemStyle: {
							borderRadius: 3
						}
					})
				})
				this.vehicleDistributionOptions = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						top: '0',
					},
					xAxis: {
						type: 'value',
						show: false,
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: xAxis
					},
					series: [{
						name: '车辆：',
						type: 'bar',
						barWidth: 15,
						label: {
							show: true,
							position: 'right'
						},
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
								{ offset: 0, color: '#3EFFF4' },
								{ offset: 1, color: '#B2FEFC' }
							])
						},
						data: yAxis
					}]
				}
				this.vehicleDistributionShow = true
			})
			.catch((err) => {
				console.log(err)
			});
		},

		// 换电次数时间分布
		powerChangeTime(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo_shengshi-充换电次数时间分布',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000',
				'@OPER_TYPE': '充换电'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// 时间排序
				let data = res.sort(function(a, b){ return a.cur_hour - b.cur_hour })
				let xAxis = []
				let seriesData1 = []
				let seriesData2 = []
				data.map(item => {
					xAxis.push(item.cur_hour)
					seriesData1.push(item.exchange_num)
					seriesData2.push(item.charge_num)
				})
				this.powerChangeTimeOptions = {
					colors: ['#1CD3F3', '#7C6AF2'],
					title: {
						text: '次'
					},
					legend: {
						right: 'left',
						itemWidth: 10,
						itemHeight: 10,
						textStyle: {
							color: '#fff'
						},
						data: ['充电次数', '换电次数']
					},
					tooltip: {
						trigger: 'axis',
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: xAxis,
					}],
					yAxis: [{
						type: 'value',
					}],
					series: [
					{
						name: '充电次数',
						type: 'line',
						// stack: 'Total',
						smooth: true,
						lineStyle: {
							width: 2,
							color: '#1CD3F3'
						},
						itemStyle: {
						  normal: {
						    color: '#1CD3F3'
						  }
						},
						showSymbol: false,
						areaStyle: {
							opacity: 0.8,
							color: 'rgba(28, 211, 243, .2)'
						},
						emphasis: {
							focus: 'series'
						},
						data: seriesData2
					},
					{
						name: '换电次数',
						type: 'line',
						// stack: 'Total',
						smooth: true,
						lineStyle: {
							width: 2,
							color: '#7C6AF2'
						},
						itemStyle: {
						  normal: {
						    color: '#7C6AF2'
						  }
						},
						showSymbol: false,
						areaStyle: {
							opacity: 0.8,
							color: 'rgba(124, 106, 242, .2)'
						},
						emphasis: {
							focus: 'series'
						},
						data: seriesData1
					}]
				}
				this.powerChangeTimeShow = true
			}) 
			.catch((err) => {
				console.log(err)
			});
		},
		
		clickMapBtn() {
			this.changeMapBtn = !this.changeMapBtn;
			localStorage.setItem('changeMapBtn', this.changeMapBtn);
		},

		goback() {
			window.history.back(-1)
		}

	},
}
</script>

<style lang="scss" scoped>
.vehicle-map {
	width: 100%;
	height: 980px;
	// margin-top: 20px;
	position: relative;
	background: url(~@/assets/images/comm/bg.png) center bottom no-repeat;
	background-size: 80% 60%;
	.left, .right {
		position: absolute;
		// flex-shrink: 0;
		top: 0;
		width: 400px;
		height: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 20px;
		z-index: 10;
		:first-child {
			margin-top: 0;
		}
		> div {
			margin-top: 20px;
			flex: 1;
		}
	}
	.left {
		left: 0;
		.zonghe {
			flex-wrap: wrap;
			// justify-content: center;
			align-items: center;
			height: 100%;
			padding: 15px 0;
			> div {
				// flex: 1;
				display: flex;
				flex-direction: column;
				justify-content: center;
				// align-items: center;
				padding-left: 40px;
				.label {
					font-size: 14px;
					white-space: nowrap;
				}
				.value {
					font-size: 20px;
					font-weight: bold;
				}
        .unit{
          font-size: 14px;
					font-weight: bold;
        }
			}
		}
	}
	.right {
		right: 0;
	}
	.center {
		// flex: 1;
		width: 100%;
		height: 100%;
		position: relative;
		.goback {
			position: absolute;
			top: 10px;
			left: 450px;
			width: 100px;
			height: 50px;
			// border: 1px solid #1A7683;
			background: linear-gradient(180deg, rgba(14,134,139,0.88) 0%, rgba(0,43,41,0.6) 100%);
			display: flex;
			align-items: center;
			justify-content: center;
			border-radius: 4px;
			cursor: pointer;
			.location {
				width: 20px;
				height: 20px;
				margin-right: 15px;
				transform: rotate(180deg);
			}
		}
	}
}
.show2dBtn {
	background: url('~@/assets/images/index/3d_1.png');
	background-size: 100% 100%;
	display: block;
	position: fixed;
	width: 20px;
	height: 20px;
	margin-right: 40px;
	top: 30px;
	right: 60px;
	cursor: pointer;

	&.show3dBtn {
		background: url('~@/assets/images/index/2d_1.png');
		background-size: 100% 100%;
	}
}
</style>
